import { Helmet } from "react-helmet-async";

export const PublicErrorMetaTags = (): JSX.Element | null => {
  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
};
